import Icon from '@/components/Icon'
import { PaymentOptionContent, PaymentOptionIcon, PaymentOptionWrapper, PaymentRadioButton } from './Payment.styles'

const PaymentOption = ({ children, icon, active, onClick }) => {

  return (
    <PaymentOptionWrapper $active={active} onClick={onClick}>
      <PaymentOptionContent style={{ display: 'flex', alignItems: 'center' }}>
        <PaymentRadioButton $active={active} />
        <h2 style={{ margin: 0 }}>{children}</h2>
      </PaymentOptionContent>
      <PaymentOptionIcon>
        <Icon name={icon} />
      </PaymentOptionIcon>
    </PaymentOptionWrapper>
  )
}

export default PaymentOption

